export default __webpack_public_path__ + "static/media/ssb_logo.e521d0a9.png";